import { CustomDialog } from "../../../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { CustomLabelInput } from "../../../../../../../../../components/input/CustomLabelInput";
import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import CustomBlockButton from "../../../../../../../../../components/button/CustomBlockButton";
import _ from "lodash";
import { customToast } from "../../../../../../../../../components/toast/custom-react-toastify/v1";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    input{
        border-color: #e0e0e0;
        border-radius: 3px;
    }
`;

const StyledFooter = styled.div`
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    button{
        width: 100px;
        border-radius: 3px;
        background-color: #333;
        color: #fff;
        border: none;
        font-weight: 600;

        &.cancel{
            background-color: #efefef;
            color: #333;
        }
    }
`;

export function FragmentEditPurchaseUrlModal({
    open,
    onClose,
    purchaseUrl,
    onConfirm
}) {
    const [formData, setFormData] = useState(_.cloneDeep(purchaseUrl))

    const handleSubmit = async () => {
        // 예외처리
        if (!formData?.memo) {
            customToast.error('메모를 입력해주세요.');
            return;
        }
        if (!formData?.url) {
            customToast.error('URL을 입력해주세요.');
            return;
        }
        onConfirm(formData);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>구매처 URL 수정</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                >
                    <StyledBody>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.memo || ''}
                                onChange={(e) => setFormData({ ...formData, memo: e.target.value })}
                                autoFocus
                            />
                            <CustomLabelInput.Label>메모</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='text'
                                value={formData?.url || ''}
                                onChange={(e) => setFormData({ ...formData, url: e.target.value })}
                            />
                            <CustomLabelInput.Label>URL (https://www.example.com)</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledBody>
                    <StyledFooter>
                        <CustomBlockButton
                            type='button'
                            className='cancel'
                            onClick={onClose}
                        >
                            취소
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='submit'
                        >
                            확인
                        </CustomBlockButton>
                    </StyledFooter>
                </form>
            </CustomDialog>
        </>
    );
}